import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { customerValues } from '@/mocks/smart-farm-solution';

export default function Value() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="客户价值"
          title="服务农业产业链上的每一类主体"
          subtitle="从种植端到消费端、从经营主体到管理部门，智慧农场为不同角色提供各自需要的数字化能力与价值。"
        />
        <Reveal className="mt-12">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
            {customerValues.map((group) => (
              <div
                key={group.id}
                className="p-6 rounded-lg bg-background-100 border border-background-200 transition-all duration-300 hover:-translate-y-1.5 hover:shadow-[0_12px_32px_rgba(0,0,0,0.08)]"
              >
                <div className="flex items-center gap-3">
                  <div className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${group.icon} text-xl`}></i>
                  </div>
                  <h3 className="font-heading font-bold text-foreground-950 text-lg leading-snug">
                    {group.title}
                  </h3>
                </div>
                <ul className="mt-5 space-y-3">
                  {group.points.map((point) => (
                    <li key={point} className="flex items-start gap-2.5">
                      <i className="ri-check-line text-accent-600 mt-0.5 shrink-0"></i>
                      <span className="text-sm text-foreground-600 leading-relaxed">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}